import { Box, Paper, useTheme } from "@mui/material";
import ToolRequestForm from "../../components/forms/toolsForm/toolRequestForm.component";
import { useIsMobile } from "../../hook/useIsMobile";
import { useEffect, useState } from "react";
import SuccessDialog from "../../components/muiDialogs/successDialog.component";
import { dialogMessages } from "../../components/forms/utils";
import { useNavigate } from "react-router";

const buttons = (handleDialogConfirm, handleDialogNavigate) => [
  {
    variant: "outlined",
    label: "Vai alla Dashboard",
    action: handleDialogConfirm,
  },
  {
    variant: "contained",
    label: "I miei strumenti",
    action: handleDialogNavigate,
  },
];

const AddToolRequestPage = () => {
  const theme = useTheme();
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);

  const handleFormSuccess = (success) => {
    setIsFormSubmitted(success);
  };
  const handleSuccessDialogConfirm = () => {
    setOpenDialog(false);
    navigate("/home");
  };
  const handleSuccessDialogNavigate = () => {
    navigate("/tools");
  };

  useEffect(() => {
    if (isFormSubmitted) {
      setOpenDialog(true);
    }
  }, [isFormSubmitted]);
  return (
    <Box width="100%" height="100%">
      <Paper
        sx={{
          p: 5,
          width: "100%",
          overflowX: "auto",
          height: "100%",
        }}
        elevation={0}
      >
        <ToolRequestForm
          theme={theme}
          isMobile={isMobile}
          onSuccessChange={handleFormSuccess}
        />
      </Paper>
      <SuccessDialog
        open={openDialog}
        onClose={handleSuccessDialogConfirm}
        title={dialogMessages.addToolRequest.title}
        description={dialogMessages.addToolRequest.description}
        buttons={buttons(handleSuccessDialogConfirm, handleSuccessDialogNavigate)}
      />
    </Box>
  );
};

export default AddToolRequestPage;
